module.exports = __webpack_public_path__ + "static/media/han_mai.4449e2dd.png";